<template>
  <div class="bottom-action-container" :class="{'dashboard': inDashboard}">
    <div class="start-container">
      <slot>

      </slot>
    </div>
    <div class="end-container">
      <slot name="end">

      </slot>
    </div>
  </div>
</template>
<script>

export default {
  computed: {
    inDashboard() {
      if (this.$route.path.match(/dashboard/g)) {
        return true;
      } else {
        return false;
      }
    }
  }
}

</script>
